import React, { useContext } from 'react';

import { OverlayType } from '../../../constants';
import { canFilterByTournamentOnMobile } from '../../../utils';
import FeaturedTournamentsList from '../FeaturedTournamentsList';
import { MobileFiltersCtx } from '../MobileFiltersCtx';
import TournamentList from '../TournamentList';

const Overlay: React.FC = () => {
    const { currentOverlay } = useContext(MobileFiltersCtx);

    switch (currentOverlay) {
        case OverlayType.FEATURED_TOURNAMENTS_LIST: {
            return <FeaturedTournamentsList />;
        }

        case OverlayType.TOURNAMENT_LIST: {
            if (!canFilterByTournamentOnMobile()) return null;

            return <TournamentList />;
        }

        default: {
            return null;
        }
    }
};

export default Overlay;
